import React from "react";
import styles from "./styles.module.css";

const NavPanel = ({
  title,
  titleExtra,
  header,
  meta,
  items,
  activeKey,
  onSelect,
  onLocked,
}) => {
  const entries = (items ?? []).filter((i) => i && i.key);
  if (entries.length === 0 && !header) return null;

  return (

    <aside className={styles.panel} data-nav-panel="true">
      {title && (
        <div className={styles.title}>
          <span className={styles.titleText}>{title}</span>
          {titleExtra}
        </div>
      )}
      {}
      {header && <div className={styles.header}>{header}</div>}
      {/* Below the header's rule, above the menu: page-supplied detail about
          whatever the header names — not part of the switcher, not an item. */}
      {meta && <div className={styles.meta}>{meta}</div>}
      <div className={styles.items}>
        {entries.map((item) => {
          /* Group headings label the entries under them; they are not
             destinations. Rendered as buttons they were clickable, and the key
             of a heading is not a route, so pressing one navigated somewhere
             arbitrary. */
          if (item.type === "group") {
            return (
              <div className={styles.group} key={item.key}>
                {item.label}
              </div>
            );
          }

          /* Same for a disabled entry — an empty-state line explaining what a
             group is for has nowhere to go. */
          if (item.disabled) {
            return (
              <div className={styles.itemDisabled} key={item.key}>
                {item.icon && (
                  <span className={styles.itemIcon}>{item.icon}</span>
                )}
                <span className={styles.itemLabel}>{item.label}</span>
              </div>
            );
          }

          return (
            <button
              key={item.key}
              type="button"
              aria-current={activeKey === item.key ? "page" : undefined}
              className={`${styles.item} ${
                activeKey === item.key ? styles.itemActive : ""
              } ${item.locked ? styles.itemLocked : ""}`}
              onClick={() =>
                item.locked ? onLocked?.(item) : onSelect(item.key)
              }
            >
              {item.icon && (
                <span className={styles.itemIcon}>{item.icon}</span>
              )}
              <span className={styles.itemLabel}>{item.label}</span>
              {item.extra && (
                <span className={styles.itemExtra}>{item.extra}</span>
              )}
            </button>
          );
        })}
      </div>
    </aside>
  );
};

export default NavPanel;
